import React from 'react';
import BaseComponent from './BaseComponent';
import Button from './Button';
import Style from './PopupList.cssmodule.less';

class PopupList extends BaseComponent {
    constructor(props) {
        super(props);
        this.setTheme(props.theme);
        this.handleClickEvent = this.handleClickEvent.bind(this);
    }

    setTheme(theme) {
        const themeStyle = this.getTheme(theme, 'POPUP_LIST');
        this.Style = themeStyle || Style;
    }

    handleClickEvent(e, data) {
        this.props.emitter.emit('click', e, data);
    }

    createHintPopupList() {
        let { content = [] } = this.props;
        if(!Array.isArray(content)) {
            return ;
        }
        content = content.filter((c) => {
            return c;
        });
        let hintList = [];

        content.forEach((data = {}, idx) => {
            if (data.type === 'hint' || data.type === 'prebuilt_hint') {
                let title;

                if (data.type === 'hint') {
                    title = data.title || this.getLang('Buttons.default_hint_title');
                } else {
                    title = data.items.title || '';
                }

                hintList.push(
                    <div
                        className={this.Style.hint}
                        key={idx}
                        onClick={(e) => {
                            this.handleClickEvent(e, {
                                type: data.type,
                                value: idx,
                            });
                        }}
                    >
                        <div className={this.Style.hintText}>{title}</div>
                    </div>
                );
            }
        });

        return <div>{hintList}</div>;
    }

    render() {
        return (
            <div className={this.Style.popupList}>
                <div className={this.Style.buttonArea}>
                    <Button
                        className={this.Style.button}
                        onClick={(e) => {
                            this.handleClickEvent(e, {
                                type: 'intro',
                            });
                        }}
                    >
                        {this.getLang('Buttons.mission')}
                    </Button>
                    <Button
                        className={this.Style.button}
                        onClick={(e) => {
                            this.handleClickEvent(e, {
                                type: 'default',
                            });
                        }}
                    >
                        {this.getLang('Buttons.basic_guide')}
                    </Button>
                </div>
                {this.createHintPopupList()}
            </div>
        );
    }
}

PopupList.displayName = 'PopupList';
PopupList.propTypes = {};

export default PopupList;



// WEBPACK FOOTER //
// ./components/CommonSet/PopupList.js